
/* 
  菜单配置
*/

// 按钮
const {
  switch_status_power,
  increase_power,
  delete_power,
  update_power
} = {
  // 禁用启用 开关
  switch_status_power: {
    type: "Button",
    title: "禁用启用",
  },
  increase_power: {
    type: "Button",
    title: "添加",
  },
  delete_power: {
    type: "Button",
    title: "删除",
  },
  update_power: {
    type: "Button",
    title: "修改",
  }
}

const data={
  // 平台
  manage:[{
    child: [{
      ...increase_power,
      target: "increase-device",
    }, {
      ...delete_power,
      target: "delete-device",
    }, {
      ...switch_status_power,
      target: "switch-device",
    }],
    href: "/manage-device",
    icon: "el-icon-cpu",
    target: "",
    title: "设备管理",
    type: "WebPage"
  }, {
    child: [{
      ...switch_status_power,
      target: "switch-small-user",
    }, {
      ...switch_status_power,
      target: "switch-small-user-device",
    }],
    href: "/manage-apply-user",
    icon: "el-icon-user",
    target: "",
    title: "用户管理",
    type: "WebPage"
  }, {
    child: [{
      ...increase_power,
      target: "increase-business",
    }, {
      ...increase_power,
      target: "increase-device",
    }, {
      ...delete_power,
      target: "delete-device",
    }, {
      ...update_power,
      target: "update-business",
    }],
    href: "/manage-business-user",
    icon: "el-icon-s-custom",
    target: "",
    title: "经销商管理",
    type: "WebPage"
  }, {
    child:[],
    href: "/statistics",
    icon: "el-icon-s-marketing",
    target: "",
    title: "设备比例",
    type: "WebPage"
  }],
  // 经销商
  business:[{
    child: [{
      ...increase_power,
      target: "increase-business",
    }, {
      ...increase_power,
      target: "increase-device",
    }, {
      ...delete_power,
      target: "delete-device",
    }, {
      ...update_power,
      target: "update-business",
    }],
    href: "/business-item",
    icon: "el-icon-s-custom",
    target: "",
    title: "经销商",
    type: "WebPage"
  }]
}

// 菜单
export const menu = data.business
